import { render, staticRenderFns } from "./TabPicking.vue?vue&type=template&id=21ae67a6"
import script from "./TabPicking.vue?vue&type=script&lang=js"
export * from "./TabPicking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports